module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/defaultAvatar-cd5956d43bb88d3707ec2f6d0ce9b73f.png";